var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WhySectionList"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"Item"},[_c('svgicon',{staticClass:"Item__checkmark",attrs:{"icon":"checkmark"}}),_vm._v(_vm._s(item)+"\n    ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }